import PropTypes from "prop-types"
import { Box, Button, Stack, Typography } from "@mui/material"
import useAuth from "minimals-template/components/@hooks/useAuth"
import Iconify from "minimals-template/components/Iconify"

// FIQ-578: shown instead of the indefinite "Auth Guard" spinner when the
// account/client boot queries fail or time out. Gives the user the two
// recovery paths that previously required manually clearing site data:
// retrying the load, or logging out (which clears the local session token).
export function AuthGuardFailure({ onRetry }) {
    const { logout } = useAuth()

    return (
        <Box
            sx={{
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 3,
            }}
        >
            <Stack
                spacing={2}
                alignItems="center"
                sx={{ maxWidth: 440, textAlign: "center" }}
                data-cy="auth-guard-failure"
            >
                <Iconify icon="mdi:cloud-alert" sx={{ width: 48, height: 48, color: "warning.main" }} />
                <Typography variant="h5">We&apos;re having trouble loading your account</Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    This is usually a temporary connection problem. You can try again, or log out and sign back in with
                    a fresh session.
                </Typography>
                <Stack direction="row" spacing={2}>
                    <Button variant="contained" onClick={onRetry} data-cy="auth-guard-retry">
                        Try again
                    </Button>
                    <Button variant="outlined" onClick={handleLogout} data-cy="auth-guard-logout">
                        Log out
                    </Button>
                </Stack>
            </Stack>
        </Box>
    )

    function handleLogout() {
        logout().catch(console.error)
    }
}

AuthGuardFailure.propTypes = {
    onRetry: PropTypes.func,
}
